import app from 'app';
import wtVideoInformationComponent from './component.vue';

export default function (story, { canAdjustThumbnail }) {
  return new Promise((res, rej) => {
    const modal = app.showModal({
      type: 'big',
      component: wtVideoInformationComponent,
      store: app.rootStore,
      componentPropsData: {
        story,
        canAdjustThumbnail: !!canAdjustThumbnail,
      },
    });
    modal.$on('close', (data = {}) => {
      if (data.id) {
        res(data);
      }
      rej();
    });
  });
}
